import type { Signals, Motif, MapRecord } from './types'

export const CARE_LABELS: Record<string, string> = {
  repair: 'Repair after rupture',
  accountability: 'Owning impact',
  information: 'Delivering or requesting clarity',
  affection: 'Maintaining the thread',
  boundary: 'Asking for space or limits',
  request: 'Asking for support or help',
  celebration: 'Good news or joy',
  other: 'Something else'
}

export const MOTIF_LABEL: Record<Motif, string> = {
  fog: 'Fog bank',
  knot: 'Tangled thread',
  letters: 'Stack of letters',
  horizon: 'Open horizon',
  door: 'Slightly open door',
  window: 'Lit window',
  thread: 'Single thread',
  arch: 'Stone arch'
}

export function shortId(id: string) { return id.slice(0, 8) }

export function formatDate(iso: string) {
  try {
    return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(iso))
  } catch { return iso }
}

export function computeSignatureString(signals: Signals): string {
  const care = signals.care_burdens[0] || 'mixed'
  const ant = ['low', 'med', 'high'][signals.anticipation.level - 1]
  const mem = ['low', 'med', 'high'][signals.memory.level - 1]
  const hand = signals.handoff.level === 3 ? 'knot' : signals.handoff.level === 2 ? 'sticky' : 'open'
  const cap = signals.capacity.level === 1 ? 'thin' : signals.capacity.level === 2 ? 'modest' : 'full'
  return `${care} • ${ant} anticipation • ${mem} memory • ${hand} handoff • ${cap} capacity`
}

export function canCarveTile(map: MapRecord): boolean {
  const s = map.signals
  const hasCare = s.care_burdens.length > 0
  const touchedAll = [s.anticipation, s.memory, s.handoff, s.capacity].every(l => l.level >= 1)
  return hasCare && touchedAll && map.anchor.trim().length > 3
}

export function levelLabel(level: 1 | 2 | 3, kind: 'load' | 'capacity' = 'load') {
  if (kind === 'capacity') {
    return level === 1 ? 'thin' : level === 2 ? 'modest' : 'present'
  }
  return level === 1 ? 'light' : level === 2 ? 'present' : 'heavy'
}

export const MOTIFS: Motif[] = ['fog', 'knot', 'letters', 'horizon', 'door', 'window', 'thread', 'arch']

export function signatureFromTile(t: { signature: string }) {
  // Parse back for filters
  return t.signature.split(',')
}
